module.exports = __webpack_public_path__ + "static/media/back-arrow.cc7650f7.svg";